import { useEffect, useState } from 'react'
import {db} from '../firebase'
import {collection, getDocs} from "firebase/firestore"

//si me sale erores con referente a los permisos entrar aqui:
//https://stackoverflow.com/questions/46590155/firestore-permission-denied-missing-or-insufficient-permissions
export const useFirestore = () => {

    const [data, setData] = useState([])
    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)

    
       
    const getData = async() => {
        //console.log(auth.currentUser);
        try{
            setLoading(true);
            const dataRef = collection(db, "productos");
            //const q = query(dataRef,where("uid", "==", auth.currentUser.uid))
            const querySnapshot = await getDocs(dataRef);
            const dataDB = querySnapshot.docs.map((doc) => doc.data());
            setData(dataDB);
        } catch (error) {
            console.log(error)
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getData();     
    }, [])

  return [
    data,
    error, 
    loading
    
  ];
}

export default useFirestore